import {Component, ChangeDetectionStrategy} from '@angular/core';

@Component({
    selector: 'app-flux-search-export',
    templateUrl: './flux-search-export.component.html',
    styleUrls: ['./flux-search-export.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FluxSearchExportComponent {
  type: string;

  constructor() { }
}
